module.exports = __webpack_public_path__ + "img/ad.abb4ef0d.svg";